  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span> Filtragem dos Dados - Pesquisa GLOBAL</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">

      <v-col class="d-flex" cols="4" sm="5">
          <v-text-field
            v-model="pesquisa"
            label="Informe o número de matricula"
          ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="4" sm="3" >

          <v-btn :disabled="pesquisa === ''" color="primary" @click="Pesquisar()"><v-icon>search</v-icon></v-btn>

      </v-col>
     <v-col class="d-flex" cols="4" sm="4" >

          <label style="color:red" v-if="!msg_pesquisa">Estudante não encontrado!</label>

      </v-col>

    </v-row>
    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados Pessoais</strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.estudante_dados.length)?(this.estudante_dados[0].nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.estudante_dados.length)?(this.estudante_dados[0].idMatricula):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="4">
          <v-chip style="margin:4px">Genero:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].sexo):''}}</strong></v-chip>
     </v-col>
     <v-col md="8">
          <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].datanascimento):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Natural de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">BI:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].bi):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Filho de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">e De:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedamae):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="12">
          <v-chip style="margin:4px">Contacto:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].telefone):''}}</strong></v-chip>
     </v-col>

    </v-row>
    <v-row>

        <v-col>

            <v-col md="12">
        <v-chip
              color="pink" style="margin:4px;color:white"
            >
              Instituição Inscrito : {{(this.estudante_dados.length)?(this.estudante_dados[0].instituicao):''}}
            </v-chip>
    </v-col>

        </v-col>

    </v-row>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="this.estudante_dados"
          >

      </v-data-table>

  </v-col>

</v-row>
  </v-card>

  </v-container>

</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    idMatricula: null,
    msg_pesquisa: true,
    pesquisa: '',
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'idAno_Academico' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select

  },
  methods: {

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaGlobal/' + this.pesquisa)
          .then(res => res.data)
        this.progresso = false
        if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
